<app-user-offer-details-component offerBundleType="bundle" [offerId]="bundleId()" />
